import ReviewAndPay from 'components/HappeningNonContent/ServiceBooking/ReviewAndPay/ReviewAndPay';
import { withReviewAndPayProps } from 'viewModel/happening/withReviewAndPayProps';

export default withReviewAndPayProps(ReviewAndPay);
